import React, { cloneElement } from 'react';

import Opener from './Opener';
import Assistant from './Assistant';
import { useCopywriter } from './CopywriterContext';

const Copywriter = ({ children }) => {

  if (!children) return <Assistant />;

  const { open } = useCopywriter();

  return ( <>
    <Opener>{children}</Opener>
    { open && <Assistant /> }
  </>
  );
};

export default Copywriter;
